<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-form class="form-compra">
          <b-card>
            <b-form>
              <b-form-group
                label="Banco"
                label-for="banco"
                :label-cols="labelCols"
                horizontal>
                <b-form-input 
                  id="banco" 
                  :value="banco" 
                  type="text"
                  readonly>
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Tarjeta"
                label-for="tarjetaMarca"
                :label-cols="labelCols"
                horizontal>
                <b-form-input 
                  id="tarjetaMarca" 
                  :value="tarjetaMarca"
                  type="text"
                  readonly>
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Nro.Cuenta"
                label-for="numeroCuenta"
                :label-cols="labelCols"
                horizontal>
                <b-form-input 
                  id="numeroCuenta" 
                  :value="numeroCuenta" 
                  type="text"
                  readonly>
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Fecha de Cierre"
                label-for="fechaCierre"
                :label-cols="labelCols"
                horizontal>
                <b-form-input 
                  id="fechaCierre" 
                  :value="fechaCierre | fecha" 
                  type="text"
                  readonly>
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Fecha de Vencimiento"
                label-for="fechaVencimiento"
                :label-cols="labelCols"
                horizontal>
                <b-form-input 
                  id="fechaVencimiento" 
                  :value="fechaVencimiento | fecha" 
                  type="text"
                  readonly>
                </b-form-input>
              </b-form-group>

              <app-caja
                label="Caja"
                :label-cols="labelCols"
                :nombre="cajaRegistroNombre"
                :valido="cajaRegistroValida"
                :lista="cajasRegistrosList"
                :msjInvalido="cajaRegistroInvalidaMsj"
                @validate="validate"
                @updated="cajaRegistroActualizada">
              </app-caja>  
            </b-form>
          </b-card>

          <b-card>
            <b-row>
              <b-col cols="6">
                <b-form-group
                  label="Pesos"
                  label-for="pesos"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="pesos"
                    v-model.trim="$v.pesos.$model" 
                    :state="pesosValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="pesosFeedback">
                    {{ pesosInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label="Debitos"
                  label-for="debitos"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-input-group>
                    <b-input-group-append 
                        class="filter-search-icons" 
                        @click="agregarDebito">
                      <b-input-group-text>
                        <i class="fa fa-plus"></i>
                      </b-input-group-text>
                    </b-input-group-append>
                    <b-form-input 
                      id="debitos"
                      :value="importeDebitos | moneda(moneda)"
                      :readonly="Boolean(true)">
                    </b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-table 
                    v-if="tieneDebitos"
                    hover
                    responsive="sm" 
                    class="pagos-documentos"
                    :busy="tableBusy"
                    :items="debitos" 
                    :fields="debitosFields">

                  <template v-slot:cell(fechaCreditoDebito)="data">
                    {{ data.item.fechaCreditoDebito | fecha }}
                  </template>
                  <template v-slot:cell(importe)="data">
                    {{ data.item.importe | moneda(data.item.moneda) }}
                  </template>
                  <template v-slot:cell(borrar)="data">
                    <i class="fa fa-remove" @click.stop="borrarDebito(data.item)"></i>
                  </template>
                </b-table>
              </b-col>

              <b-col cols="6">
                <b-form-group
                  label="Total A Pagar"
                  label-for="totalAPagar"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="totalAPagar"
                    :value="totalAPagar | moneda(moneda)"
                    readonly>
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Moneda"
                  label-for="moneda"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="moneda"
                    :value="moneda"
                    readonly>
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Cotizacion"
                  label-for="cotizacion"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="cotizacion"
                    v-model.trim= "$v.cotizacion.$model" 
                    :state="cotizacionValida"
                    type="text"
                    @blur.native="validate"
                    :readonly="!cotizacionEnabled">
                  </b-form-input>
                  <b-form-invalid-feedback id="cotizacionFeedback">
                    {{ cotizacionInvalidaMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label="Total Documentos"
                  label-for="totalDocumentos"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="totalDocumentos"
                    :value="totalDocumentos | moneda(moneda)"
                    :readonly="Boolean(true)">
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Saldo"
                  label-for="saldo"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="saldo"
                    :value="saldo | moneda(moneda)"
                    :readonly="Boolean(true)">
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>

          <b-card>
            <b-form-group
              label-for="observaciones">
              <b-form-textarea
                id="observaciones"
                v-model="$v.observaciones.$model" 
                rows="3"
                max-rows="6"
                :state="observacionesValidas"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="observacionesFeedback">
                {{ observacionesInvalidasMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-card>
        </b-form>
      </b-col>
    </b-row>

    <b-modal ref="addDebitoModal" 
        title="Debito En Cuenta"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-debito
        @transferenciaAgregada="debitoAgregado"
        @cancel="debitoCancelado">
      </app-debito>
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>    
  </div>
</template>

<script>
import { required, decimal, minValue, maxValue, numeric, maxLength } from 'vuelidate/lib/validators';
import Caja from '../shared/abmSelect.vue';
import Debito from '../bancosmovimientos/Movimiento.vue'
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'tarjetaResumenPago/getField',
  mutationType: 'tarjetaResumenPago/updateField',
});

export default {
  name: 'TarjetasResumenesPagosDocumentosABM',
  components: {
    appCaja: Caja,
    appDebito: Debito,
    appABMButton: ABMButtons,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      cajaRegistroValida: null,
      cajaRegistroInvalidaMsj: '',
      pesosValido: null,
      pesosInvalidoMsj: '',
      cotizacionValida: null,
      cotizacionInvalidaMsj: '',
      observacionesValidas: null,
      observacionesInvalidasMsj: '',
      // cotizacionValida: null,
      // cotizacionInvalidaMsj: '',

      debitosFields: [
        { 
          key: 'fechaCreditoDebito',
          label: 'Fecha'
        },
        { 
          key: 'bancoCuentaNombre',
          label: 'Cuenta'
        },
        { key: 'importe' },
        { 
          key: 'borrar',
          label: '',
          class: 'table-remove-icon' 
        },
      ],

      tableBusy: false,
      labelCols : 2,
      cajasRegistros: [],
      cajasRegistrosList: [],
    }
  },
  computed: {
    ...mapFields([
      'tarjetaResumenId',
      'banco',
      'tarjetaMarca',
      'numeroCuenta',
      'fechaCierre',
      'fechaVencimiento',
      'totalCierrePesos',
      'totalPagosPesos',
      'totalCierreDolares',
      'totalPagosDolares',

      'opcionPagoId',
      'cajaRegistro',
      'cajaRegistroNombre',
      // 'totalAPagar',
      'monedaId',
      'moneda',
      'cotizacion',
      'pesos',
      'importeDebitosPesos',
      'importeDebitosDolares',
      'debitos',
      'observaciones',
    ]),
    importeDebitos() {
      if (this.monedaId == 101) {
        return parseFloat(this.importeDebitosPesos) 
          + (parseFloat(this.importeDebitosDolares) * parseFloat(this.cotizacion));
      }
      if (this.monedaId == 102) {
        return (parseFloat(this.importeDebitosPesos) / parseFloat(this.cotizacion)) 
          + parseFloat(this.importeDebitosDolares);
      }

      return parseFloat(this.importeDebitosPesos) 
        + parseFloat(this.importeDebitosDolares);
    },    
    totalDocumentos() {
      if (this.monedaId == 101) {
        return parseFloat(this.pesos) 
          + parseFloat(this.importeDebitos);
      }
      if (this.monedaId == 102) {
        return (parseFloat(this.pesos) / parseFloat(this.cotizacion))
          + parseFloat(this.importeDebitos);
      }
      return parseFloat(this.pesos) 
        + parseFloat(this.importeDebitos);
    },
    totalAPagar() {
      switch (this.opcionPagoId) {
        case 1:
            return parseFloat(this.totalCierrePesos) - parseFloat(this.totalPagosPesos);
        case 2:
            return parseFloat(this.totalCierreDolares) - parseFloat(this.totalPagosDolares);
        case 3:
            return parseFloat(this.totalCierrePesos) - parseFloat(this.totalPagosPesos)
                + (parseFloat(this.totalCierreDolares) - parseFloat(this.totalPagosDolares)) * parseFloat(this.cotizacion);
      }
      return 0;
    },
    saldo() {
      return parseFloat(this.totalAPagar) 
        - parseFloat(this.totalDocumentos);
      // return (parseFloat(this.totalSeleccionado) * parseFloat(this.cotizacion)) - parseFloat(this.totalDocumentos);
    },
    tieneDebitos() {
      if (this.debitos) {
        if (this.debitos.length != 0) {
          return true;
        }
      }
      return false;
    },
    cotizacionEnabled() {
      if (this.monedaId == 102 || this.opcionPagoId == 3) {
        return true;
      }
      /* Verificamos si hay documentos en moneda extranjera */
      if (Array.isArray(this.debitos) && this.debitos.length > 0 ) {
        if (this.debitos.some( t => t.monedaId != 101 )) {
          return true;
        }
      }

      return false;
    }    
  },
  created() {
  },
  activated() {
    this.getDatosAdicionales();
    this.validarPagoResumen();
  },  
  methods: {
    getDatosAdicionales() {
      let vm = this;
      vm.$store.dispatch('cajasregistros/getCajasRegistrosSelect')
        .then(() => {
          vm.cajasRegistros = this.$store.getters['cajasregistros/cajasRegistrosSelect'];
          vm.cajasRegistrosList = this.$store.getters['cajasregistros/cajasRegistrosSelectList'];
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de cajas.'))
    },

    agregarDebito(){
      this.$refs.addDebitoModal.show();
    },
    debitoAgregado(debito){
      this.$refs.addDebitoModal.hide();
      this.showSpinner();
      this.$store.dispatch('tarjetaResumenPago/setDebito', debito)
        .then(() => {
          this.validarPagoResumen();
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    debitoCancelado(){
      this.$refs.addDebitoModal.hide();
    },
    borrarDebito(item){
      this.showSpinner();
      this.$store.dispatch('tarjetaResumenPago/deleteDebito', item)
        .then(() => {
          this.validarPagoResumen();
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },

    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'pesos' || validarTodos) {
        this.pesosValido = null;
        this.pesosInvalidoMsj = this.displayErrorMonto (this.$v.pesos.$error, 
          this.$v.pesos.decimal, this.$v.pesos.minValue); 
        
        if (this.pesosInvalidoMsj.trim() != '') {
          this.pesosValido = false;
        }
      }

      if (campo == 'observaciones' || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones sólo pueden contener hasta 5000 caracteres';
          }
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }
    },
    displayErrorMonto( fieldError, fieldErrorDecimal, fieldErrorMinValue) {
      let errorMsj = '';
      if (fieldError) {
        if (fieldErrorDecimal) {
          errorMsj = 'El monto ingresado debe ser un valor numérico';
        } else if (fieldErrorMinValue) {
          errorMsj = 'El monto ingresado no es válido';
        }
      }
      return errorMsj;
    },
    save() {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.displayErrores();

      let cajaRegistro;
      if (this.cajaRegistroNombre) {
        cajaRegistro = this.getSelected(this.cajasRegistros, this.cajaRegistroNombre);
      }
      this.$store.dispatch('tarjetaResumenPago/setCajaRegistro', cajaRegistro);

      let cajaRegistroError = true;
      if (this.cajaRegistro) {
        if (this.cajaRegistro.id) {
          if (this.cajaRegistro.id != 0) {
            cajaRegistroError = false;
          }
        }
      }
      if (cajaRegistroError) {
        save = false;
        this.cajaRegistroValida = false;
        this.cajaRegistroInvalidaMsj = 'Debe seleccionar la caja correspondiente.';
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('tarjetaResumenPago/save')
            .then(() => this.showModalMsj('El pago del resumen se registró con éxito', this.goList, this.goList, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    cajaRegistroActualizada(nombre) {
      this.cajaRegistroNombre = nombre;
      
      if ( this.cajaRegistroNombre ) {
        this.cajaRegistroValida = null;
        this.cajaRegistroInvalidaMsj = '';
      }

      this.validarPagoResumen();
    },
    validarPagoResumen() {
      let isValid = true;
      
      if (this.totalDocumentos == 0 && this.totalAPagar == 0) {
        isValid = false;
      }

      if (this.$v.observaciones.$error || this.$v.pesos.$error || this.$v.cotizacion.$error) {
        isValid = false;
      }

      if (!this.cotizacionEnabled) {
        this.cotizacion = 1;
      }

      this.displayErrores();

      if (this.cajasRegistros) {
        if (this.cajasRegistros.length != 0) {
          let cajaRegistro;
          if (this.cajaRegistroNombre) {
            cajaRegistro = this.getSelected(this.cajasRegistros, this.cajaRegistroNombre);
          }
          this.$store.dispatch('tarjetaResumenPago/setCajaRegistro', cajaRegistro);

          if (this.cajaRegistro) {
            if (this.cajaRegistro.id == 0){
              isValid = false;
              this.cajaRegistroValida = false;
              this.cajaRegistroInvalidaMsj = 'Debe seleccionar la caja correspondiente.';
            }
          } else {
            isValid = false;
            this.cajaRegistroValida = false;
            this.cajaRegistroInvalidaMsj = 'Debe seleccionar la caja correspondiente.';
          }
        } else {
          isValid = false;
        }
      } else {
        isValid = false;
      }

      if(isValid) {
        this.$emit('can-continue', { value: true });
      } else {
        this.$emit('can-continue', { value: false });
      }
    },
  },
  validations: {
    pesos: { decimal, minValue: minValue(0) },
    cotizacion: { decimal, minValue: minValue(0) },
    observaciones: {
      maxLength: maxLength(5000)
    },
  },
  watch: {
    'pesos' : function(newVal, oldVal) {
      if ( newVal != oldVal) {
        this.validarPagoResumen();
      }
    },
    'cotizacion' : function(newVal, oldVal) {
      if ( newVal != oldVal) {
        this.validarPagoResumen();
      }
    },
  },  
}
</script>

<style>
</style>
